<template>
  <validator name="validator">
    <form novalidate>
      <div class="card card-content" transition="fade" v-if="show">
        <div class="card-header">
          <div class="header">
            <div class="breadcrumb">
              <a class="breadcrumb-item" v-link="{ path: '/'}">Accueil</a>
              <a class="breadcrumb-item" v-link="{ path: '/contact/list'}">Gestion des participants</a>
              <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">{{ contact.leader_firstname }} {{ contact.leader_lastname }}</a>
              <a class="breadcrumb-item" v-link="{ name: 'editContact', params: { contactId: this.contact.id } }">Informations</a>
            </div>
            <h1>{{ contact.leader_firstname }} {{ contact.leader_lastname }}</h1>
          </div>
          <div class="actions">
            <a class="btn btn-link" v-link="{ path: '/contact/list' }">Voir tous les participants</a>
            <a class="btn btn-link" v-link="{ name: 'addProjectWithContact', params: { contactId: contact.id } }">Ajouter un parcours</a>
            <a class="btn btn-link" v-link="{ name: 'addMeetingWithContact', params: { contactId: contact.id } }">Ajouter un rdv</a>
            <button class="btn btn-link" v-on:click.prevent="saveContact" :class="{ disabled: !$validator.valid }">
                Sauvegarder le participant
            </button>
          </div>
        </div>
        <div class="card-block">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <a class="nav-link active" v-link="{ name: 'editContact', params: { contactId: contact.id }}">Informations</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-link="{ name: 'parcoursContact', params: { contactId: contact.id }}">Parcours</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-link="{ name: 'planningContact', params: { contactId: contact.id }}">Planning</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-link="{ name: 'editContact.entreprises', params: { contactId: contact.id }}">Entreprises</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-link="{ name: 'editContact.emplois', params: { contactId: contact.id }}">Emplois</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-link="{ name: 'editContact.formations', params: { contactId: contact.id }}">Formations</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-link="{ name: 'editContact.capes', params: { contactId: contact.id }}">CAPE</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" v-link="{ name: 'editContact.cers', params: { contactId: contact.id }}">CER</a>
            </li>
          </ul>
        </div>
        <div class="card-block">
          <fieldset>
            <legend>Informations générales</legend>
			<div class="row">
            <div class="col-sm-6">
              <label for="gender">Civilité *</label>
              <select id="gender" name="gender" v-model="contact.gender" class="form-control"
                      v-validate:gender="validationRules.gender">
                <option value=""></option>
                <option v-for="gender in genders" :value="gender.value">{{ gender.label }}</option>
              </select>
              <small class="form-text text-danger" v-if="$validator.gender.required">Vous devez choisir un titre</small>
            </div>
			<div class="col-sm-6">
			  <!-- Firstname -->
				<div class="form-group">
				  <label for="leader_firstname">Prénom *</label>
				  <input class="form-control"
						 id="leader_firstname"
						 type="text"
						 v-model="contact.leader_firstname"
						 v-validate:leader_firstname="validationRules.leader_firstname"
				  >
				  <small class="form-text text-danger" v-if="$validator.leader_firstname.required">Vous devez indiquer
					un nom
				  </small>
				</div>
			  </div>
			  </div>
            <div class="row">
              <div class="col-sm-6">
                <!-- Lastname -->
                <div class="form-group">
                  <label for="leader_lastname">Nom d'usage *</label>
                  <input class="form-control"
                         id="leader_lastname"
                         type="text"
                         v-model="contact.leader_lastname"
                         v-validate:leader_lastname="validationRules.leader_lastname"
                         v-uppercase="contact.leader_lastname"
                  >
                  <small class="form-text text-danger" v-if="$validator.leader_lastname.required">Vous devez indiquer un
                    nom
                  </small>
                </div>
              </div>
              <div class="col-sm-6">
                  <!-- Lastname -->
                  <div class="form-group">
                      <label for="leader_lastname">Nom de jeune fille</label>
                      <input class="form-control"
                             id                         = "nom_origin"
                             type                       = "text"
                             v-model                    = "contact.nom_origin"
                             v-validate:nom_origin      = "validationRules.nom_origin"
                             v-uppercase                = "contact.nom_origin"
                      >
                  </div>
              </div>

            </div>
			<div class="row">
              <div class="col-sm-6">
                <!-- Phone -->
                <div class="form-group">
                  <label for="phone">Téléphone</label>
                  <input class="form-control"
                         id="phone"
                         type="text"
                         v-model="contact.phone"
                         v-validate:phone="validationRules.phone"
                  >
                  <small class="form-text text-danger" v-if="$validator.phone.validatePhone">Vous devez indiquer un
                    téléphone valide
                  </small>
                </div>
              </div>
              <div class="col-sm-6">
                <!-- Mobile -->
                <div class="form-group">
                  <label for="mobile">Portable</label>
                  <input class="form-control"
                         id="mobile"
                         type="text"
                         v-model="contact.mobile"
                         v-validate:mobile="validationRules.mobile"
                  >
                  <small class="form-text text-danger" v-if="$validator.mobile.validatePhone">Vous devez indiquer un
                    téléphone mobile valide
                  </small>
                </div>
              </div>
            </div>
			<div class="row">
              <div class="col-sm-6">
                <!-- Email -->
                <div class="form-group">
                  <label for="email">Email</label>
                  <input class="form-control"
                         id="email"
                         type="text"
                         v-model="contact.email"
                         v-validate:email="validationRules.email"
                  >
                  <small class="form-text text-danger" v-if="$validator.email.validateEmail">L'adresse email fournie
                    n'est pas valide
                  </small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <!-- Birth date -->
                <div class="form-group">
                  <label for="startTime">Date de naissance</label>
                  <!--
                  <date-picker
                    :time.sync="contact.date_birth"
                    :option="datepickerOptions"
                    :inputClass="form-control"
                  ></date-picker>
                  -->
                  <input
                    id               = "date_birth"
                    class            = "form-control"
                    type             = "text"
                    v-model          = "contact.date_birth"
	          >
                  <small class="form-text text-danger" v-if="$validator.date_birth.validateDate">Vous devez indiquer une
                    date valide
                  </small>
                </div>
              </div>
			  <div class="col-sm-6">
                <!-- Birth city -->
                <div class="form-group">
                  <label for="city_birth">Ville de naissance</label>
                  <input class="form-control"
                         id="city_birth"
                         type="text"
                         v-model="contact.city_birth"
                  >
                </div>
              </div>

            </div>
			<div class="row">

              <div class="col-sm-6">
                <!-- Birth country -->
                <div class="form-group">
                  <label for="country_id">Pays de naissance</label>
                  <select id="country_id" name="country_id" v-model="contact.country_id" class="form-control">
                    <option value=""></option>
                    <option v-for="country in countries" v-bind:value="country.id">{{ country.name }}</option>
                  </select>
                </div>
              </div>
			  <div class="col-sm-6">
                <!-- Nationality -->
                <div class="form-group">
                  <label for="nationality">Nationalité</label>
                  <input class="form-control"
                         id="nationality"
                         type="text"
                         v-model="contact.nationality"
                  >
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>Adresse</legend>

            <div class="row">
              <div class="col-sm-6">
                <!-- Address -->
                <div class="form-group">
                  <label for="address">Adresse</label>
                  <input class="form-control"
                         id="address"
                         type="text"
                         v-model="contact.address"
                  >
                </div>
              </div>
              <div class="col-sm-6">
                <!-- Address complement -->
                <div class="form-group">
                  <label for="address_compl">Complément</label>
                  <input class="form-control"
                         id="address_compl"
                         type="text"
                         v-model="contact.address_compl"
                  >
                </div>
              </div>
			  </div>
			  <div class="row">
              <div class="col-sm-6">
                <!-- zip -->
                <div class="form-group">
                  <label for="zip">Code postal</label>
                  <input class="form-control"
                         id="zip"
                         type="text"
                         v-model="contact.zip"
                         v-validate:zip="validationRules.zip"
                  >
                  <small class="form-text text-danger" v-if="$validator.zip.minLength || $validator.zip.maxLength">Vous
                    devez indiquer un code postal valide
                  </small>
                </div>
              </div>
              <div class="col-sm-6">
                <!-- City -->
                <div class="form-group">
                  <label for="city">Ville</label>
                  <input class="form-control"
                         id="city"
                         type="text"
                         v-model="contact.city"
                         v-validate:city="validationRules.city"
                  >
                </div>
              </div>
        </div>
			  <div class="row">
                <div class="col-sm-6">
                   <!-- political_district -->
                  <div class="form-group">
                    <switch :value.sync = "contact.political_district" >Quartier politique de la ville</switch>
                  </div>
                 </div>
                <div class="col-sm-6">
                  <!-- political_district complement -->
                  <label for="political_district_complement">Complément quartier politique</label>
                  <div class="form-group">
                    <input class="form-control"
                          id="political_district_complement"
                          type="text"
                          v-model="contact.political_district_complement"
                    >
                  </div>
              </div>
			  </div>
          </fieldset>
          <fieldset>
            <legend>Activité</legend>
            <div class="row">
              <div class="col-sm-6">
                <!-- Education level -->
                <div class="form-group">
                  <label for="education_level_id">Niveau de formation</label>
                  <select id="education_level_id" v-model="contact.education_level_id" class="form-control">
                    <option value=""></option>
                    <option v-for="educationLevel in educationLevels" :value="educationLevel.id">{{ educationLevel.name
                      }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <!-- Driving licence -->
                <div class="">
                  <switch :value.sync = "contact.driving_licence" >Permis de conduire</switch>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <!-- Job title -->
                <div class="form-group">
                  <label for="job_title">Métier</label>
                  <input class="form-control"
                         id="job_title"
                         type="text"
                         v-model="contact.job_title"
                  >
                </div>
              </div>
              <div class="col-sm-6">
                <!-- PE identifiant -->
                <div class="form-group">
                  <label for="ipe_num">N° identifiant PE</label>
                  <input class="form-control"
                         id="ipe_num"
                         type="text"
                         v-model="contact.ipe_num"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <!-- Sector -->
                <div class="form-group">
                  <label for="sector">Secteur d'activité</label>
                  <select id="sector" v-model="contact.sector_id" class="form-control">
                    <option value=""></option>
                    <option v-for="sector in sectors" :value="sector.id">{{ sector.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <!-- Subsector -->
                <div class="form-group" v-if="contact.sector_id">
                  <label for="sub_sector_id">Secteur d'activité complémentaire</label>
                    <select id="sub_sector_id" name="sub_sector_id" v-model="contact.sub_sector_id" class="form-control">
                     <option value=""></option>
                     <option v-for="sector in sectors" :value="sector.id">{{ sector.name }}</option>
                    </select>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- Social status -->
              <div class="form-group">
                <div class="col-sm-12 social_status">
                  <label>Statut social</label>
                    <div v-for="socialStatus in socialStatusesList">
                      <switch :value.sync="socialStatus.selected">{{ socialStatus.name }}</switch>
                    </div>
                </div>
              </div>
              <!-- Code Nicola Social status pour alignement des checkbox : -->
                  <!--div v-for="socialStatus in socialStatusesList">
                    <switch :value.sync="socialStatus.selected"
                            v-on:click="hideshowSocialstatusTimer()"
                    >{{ socialStatus.name }}</switch>
                    <div class="mint-switch social_status_one_precisions">
                        <input class="form-control hide"
                               id="social_status_one_precisions"
                               type="text"
                               v-model="contact.social_status_one_precisions"
                               v-if="socialStatus.id == 4"
                        >
                    </div>
                  </div!-->
            </div>
            <div class="row">
              <div class="col-sm-6">
              <!-- Social security number -->
                <div class="form-group">
                  <label for="ss_num">N° sécu</label>
                    <input class="form-control"
                      id      = "ss_num"
                      type    = "text"
                      v-model = "contact.ss_num"
                      v-validate:ss_num="validationRules.ss_num"
                  >
                  <small class="form-text text-danger" v-if="$validator.ss_num.validateSecu">Vous devez indiquer un
                    numéro de sécu valide
                  </small>
                </div>
              </div>
              <div class="col-sm-6">
              <!-- CAF number -->
                <div class="form-group">
                  <label for="caf_num">N° allocation CAF</label>
                    <input class="form-control"
                      id      = "caf_num"
                      type    = "text"
                      v-model = "contact.caf_num"
                                    >
                </div>
              </div>
            </div>
            <div class="row allowances_precisions">
              <div class="col-sm-6">
                <!-- Allowance -->
                <div class="form-group">
                  <label for="allowance">Allocation</label>
                  <select id="allowance" name="allowance_id" v-model="contact.allowance_id" class="form-control allowance_select">
                    <option value=""></option>
                    <option v-for="allowance in allowances" :value="allowance.id" v-on:click="hideshowAllowance()">{{ allowance.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
              <!-- Allowance precisions -->
                <div class="form-group">
                  <label for="allowances_precisions">Allocation (Précision)</label>
                    <input class="form-control"
                      id      = "allowances_precisions"
                      type    = "text"
                      v-model = "contact.allowances_precisions"
                                    >
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>Situation familiale</legend>
            <div class="row">
              <div class="col-sm-6">
                <!-- Family situation -->
                <div class="form-group">
                  <label for="family_situation">Situation familiale</label>
                  <select id="family_situation" name="family_situation_id" v-model="contact.family_situation_id"
                          class="form-control">
                    <option value=""></option>
                    <option v-for="familySituation in familySituations" :value="familySituation.id">{{
                      familySituation.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <!-- Partner situation -->
                <div class="form-group">
                  <label for="partner_situation">Situation conjoint</label>
                  <select id="partner_situation" name="partner_situation_id" v-model="contact.partner_situation_id"
                          class="form-control">
                    <option value=""></option>
                    <option v-for="partnerSituation in partnerSituations" :value="partnerSituation.id">{{
                      partnerSituation.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <!-- Number of childs -->
                <div class="form-group">
                  <label for="nbchilds">Enfants à charge</label>
                  <input class="form-control"
                         id="nbchilds"
                         type="number"
                         size="2"
                         v-model="contact.nbchilds"
                  >
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset>
            <legend>Problématiques</legend>
                        <div class="form-group">
                        <div class="col-sm-12 social_status">
                            <div v-for="problematique in problematiquesList">
                                <switch :value.sync="problematique.selected">{{ problematique.name }}</switch>
                            </div>
                        </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6" v-for="issue in issuesList" >
                                <div class="">
                                    <switch :value.sync = "issue.value">{{ issue.name }}</switch>
                                </div>
                            </div>
                        </div>
            <div class="row mt-2">
              <div class="col-sm-12" v-for="autre in contact.autre_problematique">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" class="form-control" v-model="autre">
                    <span class="input-group-btn">
                      <button class="btn btn-warning" v-on:click.prevent="delAutreProblematique(autre)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-12"><button class="btn btn-secondary" v-on:click.prevent="addAutreProblematique()">Autre choix</button></div>
            </div>
          </fieldset>
          <br>
          <fieldset>
            <legend>Observations</legend>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <textarea rows="10" id="observations" v-model="contact.observations" placeholder=""
                            class="form-control"></textarea>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        <div class="card-footer">
          <div class="actions">
            <a class="btn btn-link" v-link="{ path: '/contact/list'}">Voir tous les participants</a>
            <button class="btn btn-link" v-on:click.prevent="saveContact" v-if="$validator.valid">Sauvegarder le
              participant
            </button>
          </div>
        </div>
      </div>
    </form>
  </validator>
</template>

<script>
    // Npm packages
    import toastr from 'toastr'
    import datePicker from 'vue-datepicker/vue-datepicker-1'
    import { Switch } from 'mint-ui'

    // Options
    import { datepickerOptions } from 'src/options/date'

    // Local components
    import Modal from 'src/components/modals/Modal'
    import Breadcrumb from '../nav/Breadcrumb.vue'

    // Vuex
    import {
        issues,
        sectors,
        countries,
        allowances,
        subSectors,
        socialStatuses,
        problematiques,
        educationLevels,
        familySituations,
        partnerSituations,
        socialStatusesOfContact,
        problematiquesOfContact,
        contact as currentContact
    } from 'src/vuex/getters'

    import { getIssues } from 'src/vuex/actions/issuesActions'
    import { getSectors } from 'src/vuex/actions/sectorsActions'
    import { getCountries } from 'src/vuex/actions/countriesActions'
    import { getAllowances } from 'src/vuex/actions/allowancesActions'
    import { getSubSectors } from 'src/vuex/actions/subSectorsActions'
    import { getSocialStatuses } from 'src/vuex/actions/socialStatusesActions'
    import { getProblematiques } from 'src/vuex/actions/problematiquesActions'
    import { getFamilySituations } from 'src/vuex/actions/familySituationsActions'
    import { getEducationLevels } from 'src/vuex/actions/educationLevelsActions'
    import { getPartnerSituations } from 'src/vuex/actions/partnerSituationsActions'
    import { getContact, editContact, getSocialStatusByContact, getProblematiqueByContact } from 'src/vuex/actions/contactActions'

    // Validation
    import { edit as validationRules } from 'src/validations/contact.js'
    import { validateEmail, validatePhone, validateDate, validateSecu } from 'src/validations/customRules.js'

    // jQuery
    import $ from 'jquery'

    import moment from 'moment'

    export default{
      vuex: {
        getters: {
          issues,
          sectors,
          countries,
          subSectors,
          allowances,
          socialStatuses,
          problematiques,
          educationLevels,
          familySituations,
          partnerSituations,
          currentContact,
          socialStatusesOfContact,
          problematiquesOfContact,
          contactUpdated: ({ contacts }) => contacts.contactUpdated
        },
        actions: {
          getIssues,
          getSectors,
          getCountries,
          getAllowances,
          getSubSectors,
          getSocialStatuses,
          getProblematiques,
          getEducationLevels,
          getFamilySituations,
          getPartnerSituations,
          getContact,
          getSocialStatusByContact,
          getProblematiqueByContact,
          editContact
        }
      },
      validators: {
        validatePhone,
        validateEmail,
        validateDate,
        validateSecu
      },
      data () {
        return {
          show: false,
          city_id: [],
          genders: [
            { label: 'Mme', value: '2' },
            { label: 'M', value: '3' }
          ],
          contact: [],
          issuesList: [],
          socialStatusesList: [],
          problematiquesList: [],
          datepickerOptions,
          validationRules,
          selectedCity: null,
          showModal: false,
          issues_selected: []
        }
      },
      watch: {
        'contact.sector_id' (value) {
          this.getSubSectors(value)
        },
        'contactUpdated': function (value) {
          if (value === true) {
            toastr.success('Le participant a bien été modifié')
          }
        },
        'issues': function () {
          if (this.contact.issue !== undefined) {
            this.updateIssuesList()
          }
        },
        'contact': function () {
          this.updateIssuesList()
          this.updateSocialStatusesList()
          this.updateProblematiquesList()
        },
        'socialStatuses': function () {
          if (this.contact.social_statuses !== undefined) {
            this.updateSocialStatusesList()
          }
        },
        'problematiques': function () {
          if (this.contact.problematiques !== undefined) {
            this.updateProblematiquesList()
          }
        }
      },
      computed: {
        name: function () {
          if (!Array.isArray(this.contact)) {
            return this.contact.leader_firstname + ' ' + this.contact.leader_lastname
          }
        }
      },
      methods: {
        hideshowSocialstatusTimer: function () {
          setTimeout(this.hideshowSocialstatus, 100)
        },
        hideshowSocialstatus: function () {
          let socialInput = $('.social_status_one_precisions input')
          if (this.socialStatusesList[5].selected === true) {
            socialInput.removeClass('hide')
          } else if (this.socialStatusesList[5].selected === false) {
            socialInput.addClass('hide')
            $('.social_status_one_precisions').val('')
          }
        },
        hideshowAllowance: function () {
          let allowanceSelected = $('.allowance_select').val()
          if (allowanceSelected === '5' && $('.allowances_precisions div:first').hasClass('col-sm-6')) {
            $('.allowances_precisions .hide').removeClass('hide')
            $('.allowances_precisions .col-sm-6:first').addClass('col-sm-3').removeClass('col-sm-6')
          } else if ($('.allowances_precisions div:first').hasClass('col-sm-3')) {
            $('.allowances_precisions .col-sm-3:first').addClass('col-sm-6').removeClass('col-sm-3')
            $('.allowances_precisions .col-sm-3:first').addClass('hide')
            $('.allowances_precisions .allowance_input').val('')
          }
        },
        saveContact () {
          // console.log('saveContact ' + this.contact)
          this.contact.issue = this.issuesList
          this.contact.social_statuses = this.socialStatusesList
          this.contact.problematiques = this.problematiquesList
          if (typeof (this.contact.date_birth) === 'undefined' || this.contact.date_birth === null || this.contact.date_birth === '' || this.contact.date_birth === 'undefined' || this.contact.date_birth === 'Invalid date') {
            this.contact.date_birth = ''
          } else {
            this.contact.date_birth = moment(this.contact.date_birth, 'DD/MM/YYYY').format('DD-MM-YYYY')
          }
          console.log('saveContact birth ' + this.contact.date_birth)
          this.editContact(this.currentContact, this.contact)
        },
        updateSelectedCity (value) { this.selectedCity = value },
        updateIssuesList () {
          this.issuesList = []
          let list = []
          let contact = this.contact
          this.issues.forEach(function (issue) {
            let selected = false
            if (Array.isArray(contact.issue)) {
              contact.issue.forEach(function (i) {
                if (i.id === issue.id) selected = true
              })
            }
            list.push({ id: issue.id, name: issue.name, value: selected })
          })
          this.issuesList = list
        },
        updateProblematiquesList () {
          let list = []
          let contact = this.contact
          this.problematiques.forEach(function (el) {
            el.selected = false
            if (Array.isArray(contact.problematiques)) {
              contact.problematiques.forEach(function (i) {
                // console.log('COMPARE ' + JSON.stringify(i.id + ' VS ' + el.id))
                // pb avec le === ; oblige de passer par stringify ou castInt
                if (i.id === el.id || JSON.stringify(i.id) === JSON.stringify(el.id)) {
                  el.selected = true
                  // console.log('SELECTED ' + el.selected)
                }
              })
            }
            list.push(el)
          })
          this.problematiquesList = list
        },
        updateSocialStatusesList () {
          let list = []
          let contact = this.contact
          this.socialStatuses.forEach(function (el) {
            el.selected = false
            if (Array.isArray(contact.social_statuses)) {
              contact.social_statuses.forEach(function (i) {
                // console.log('COMPARE ' + JSON.stringify(i.id + ' VS ' + el.id))
                // pb avec le === ; oblige de passer par stringify ou castInt
                if (i.id === el.id || JSON.stringify(i.id) === JSON.stringify(el.id)) {
                  el.selected = true
                  // console.log('SELECTED ' + el.selected)
                }
              })
            }
            list.push(el)
          })
          this.socialStatusesList = list
        },
        updateDrivingLicenceTimer: function () {
          setTimeout(this.updateDrivingLicence, 100)
        },
        updateDrivingLicence () {
          this.contact.driving_licence = $('.driving_licence .mint-switch-input').is(':checked')
        },
        updatePoliticalDistrictTimer: function () {
          setTimeout(this.updatePoliticalDistrict, 100)
        },
        updatePoliticalDistrict () {
          this.contact.political_district = $('.political_district .mint-switch-input').is(':checked')
        },
        addAutreProblematique () {
          if (!Array.isArray(this.contact.autre_problematique)) {
            this.contact.autre_problematique = []
          }
          this.contact.autre_problematique.push('')
        },
        delAutreProblematique (value) {
          this.contact.autre_problematique = this.contact.autre_problematique.filter(function (el) {
            return el !== value
          })
        }
      },
      components: { 'date-picker': datePicker, Modal, Switch, Breadcrumb },
      ready () {
        // console.log('ready')
        this.$dispatch('preview-data', [])

        let vm = this
        this.getEducationLevels()
        this.getSectors()
        this.getAllowances()
        this.getIssues()
        this.getCountries()
        this.getFamilySituations()
        this.getPartnerSituations()
        this.getSocialStatuses()
        this.getProblematiques()
        this
          .getContact(this.$route.params.contactId)
          .then(() => {
            vm.contact = JSON.parse(JSON.stringify(vm.currentContact))
            if (vm.contact.date_birth === 'Invalid date') {
              vm.contact.date_birth = ''
            }
            // api n'a pas recupéré les social_statuses
            // dev d'une fonction get pour cela précisement
            this
              .getProblematiqueByContact(this.$route.params.contactId)
              .then(() => {
                vm.contact.problematiques = vm.problematiquesOfContact
                // rafraichir l'affichage des checkbox
                vm.updateProblematiquesList()
                vm.getSocialStatusByContact(this.$route.params.contactId)
                .then(() => {
                  // retour de l'api dispatch dans socialStatusesOfContact (getters permet de faire le raccourci "contacts.socialStatusesOfContact")
                  // console.log('getSocialStatusByContact ' + JSON.stringify(vm.socialStatusesOfContact))
                  // affecter a contact.social_statuses qui devrait le contenir...
                  vm.contact.social_statuses = vm.socialStatusesOfContact
                  // rafraichir l'affichage des checkbox
                  vm.updateSocialStatusesList()
                  vm.show = true
                  setTimeout(this.hideshowAllowance, 300)
                })
              })
            /* deplacer dans le then ci-dessus
            vm.show = true
            setTimeout(this.hideshowAllowance, 300)
            */
          })
      }
    }
</script>

<style lang="scss">
//switch en affichage linéaire
.social_status .mint-switch{
    margin-top:0px!important;
    float:left;
    width:auto;
    margin-right:20px;
    margin-bottom: 5px;
}

//rectif
.political_district{
    margin-top:0px!important;
}

//ajustement de la hauteur du texte des champs
.form-control {
    font-size: 0.95rem;
}

//box statut social precision
.social_status_one_precisions{
    float: left;
    margin-left: -12px;
}
.social_status_one_precisions .form-control{
    line-height: 1.10;
}

///debug
/*
.mint-switch-input {
    display: block!important;
}
*/
</style>



// WEBPACK FOOTER //
// ContactEdit.vue?6a7f3cb5